import React from 'react'
import { getCappedImageDimensions } from '../helpers/image'
import SanityResponsiveImage from './SanityResponsiveImage'

const Image = image => {
  const { width, height } = getCappedImageDimensions(image, 1200, {
    width: 600,
    height: 320,
  })

  return (
    <SanityResponsiveImage
      image={image}
      className="object-cover w-full h-full my-4"
      width={width}
      height={height}
      widths={[320, 500, 768, 1200]}
      sizes="(min-width: 768px) 66vw, 100vw"
      alt={`${image.alt}`}
    />
  )
}

export default Image
